<template>
  <div class="container_ClientesTable">
    <div class="table-responsive">
      <b-table
        ref="tableClientes"
        :fields="visibleFields"
        :items="videosComp"
        :empty-text="$t('label.noData')"
        no-border-collapse
        show-empty
        sort-icon-left
        @sort-changed="clickAcciones('sort', $event)"
        :responsive="false"
        borderless
      >
        <template #head(actions-right)>
          <select-columns
            :fields.sync="fields"
            :pagination="pagination"
            :cod-table="columnsConfig.codTabla"
          />
        </template>
        <template #cell(actions-left)="row">
          <div class="acciones_ClientesTable">
            <div
              class="divActionCell_ClientesTable"
              v-if="showPlayVideo(row.item)"
              @click="clickAcciones('watch', row.item)"
            >
              <PIcon icon="IconPlay" size="20"></PIcon>
            </div>
            <div class="divActionCell_ClientesTable" @click="clickAcciones('download', row.item)">
              <PIcon icon="IconExcel" size="18"></PIcon>
            </div>
            <div
              class="divActionCell_ClientesTable"
              v-if="$ability.can('manage', 'VideosPage')"
              @click="clickDelete(row.item)"
            >
              <PIcon icon="IconTrash" size="18"></PIcon>
            </div>
            <b-icon
              v-if="
                row.item.estado.codParametro == 'VISUALIZADO' &&
                datosAceptados(row.item.listUsuarios) &&
                !novedadAceptada(row.item.listUsuarios)
              "
              :id="`aceptar-${row.index}`"
              class="icon-details ml-3 my-auto cursor-pointer"
              icon="check2"
              height="20"
              width="20"
              @click="clickAcciones('aceptarNovedad', row.item)"
            />
            <b-icon
              v-if="
                row.item.estado.codParametro == 'VISUALIZADO' &&
                datosAceptados(row.item.listUsuarios) &&
                !novedadAceptada(row.item.listUsuarios)
              "
              :id="`cancel-${row.index}`"
              class="ml-3 my-auto cursor-pointer"
              icon="x-lg"
              @click="clickAcciones('rechazarNovedad', row.item)"
            />
          </div>
        </template>
        <template #cell(observaciones)="row">
          <span
            v-b-tooltip.hover.d300="{ customClass: 'tooltip-observaciones' }"
            :title="row.value"
          >
            {{ row.value }}
          </span>
        </template>
        <template #cell(tipoNovedad)="row">
          <template v-if="row.value">
            {{ $t(`label.tipoNovedad.${row.value.codParametro?.toLowerCase()}`) }}
          </template>
        </template>
      </b-table>
    </div>
    <div class="mt-3" v-if="totalElements > pagination.size">
      <pagination
        :current-page="pagination.page"
        :page-size="pagination.size"
        :total-elements="totalElements"
        @change="clickAcciones('pagination', $event)"
      ></pagination>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  ICliente,
  IConfColumnaPais,
  IField,
  IPais,
  ISoConfColumnasUpdateDTO,
  IUsuario,
  IUsuarioxVideo,
  IVideo,
} from "@/entities";
import { EDirection, IColumnaResponse, IPaged } from "@/services";
import VueFilters from "@/vue-filters";
import { Action, Getter } from "vuex-class";
import {
  ESTADO_VIDEO_COMPLETADO,
  ESTADO_VIDEO_VISUALIZADO,
  MILLISECONDS_24_HORAS,
} from "@/constans";
import Pagination from "@/components/common/Pagination.vue";
import SelectColumns from "@/components/common/SelectColumns/SelectColumns.vue";
import { SweetAlertResult } from "sweetalert2";

@Component({
  components: { SelectColumns, Pagination },
  mixins: [VueFilters],
})
export class VideosTable extends Vue {
  @Prop({ required: false, default: 0 }) totalElements!: number;
  @Prop({ required: true }) value!: IPaged;
  @Prop({ required: true }) videos!: IVideo[];
  @Prop({ required: true }) public columnsConfig!: IColumnaResponse;
  @Action("saveColumna") saveColumna!: (
    params: ISoConfColumnasUpdateDTO
  ) => Promise<IColumnaResponse | undefined>;
  @Getter("getLoggedUser") getLoggerUser!: IUsuario;
  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getPaises") getPaises!: IPais[];

  pagination: IPaged = {
    direction: EDirection.DESC,
    orderBy: "fecha",
    page: 1,
    size: 10,
  };

  novedadAceptada(listUsuarios: IUsuarioxVideo[]): boolean {
    const listaUserLogged = listUsuarios.filter(
      (usuario) => usuario.fkUsuario === this.getLoggerUser.id
    );
    const ultimo = listaUserLogged[listaUserLogged.length - 1];
    return ultimo ? ultimo.aceptaNovedad !== null : false;
  }

  datosAceptados(listUsuarios: IUsuarioxVideo[]): boolean {
    const listaUserLogged = listUsuarios.filter(
      (usuario) => usuario.fkUsuario === this.getLoggerUser.id
    );
    const ultimo = listaUserLogged[listaUserLogged.length - 1];
    return ultimo ? ultimo.aceptaDatos !== null : false;
  }

  showPlayVideo(video: IVideo): boolean {
    const diasVisualizacionVideos = video.cliente.pais.diasVisualizarVideos;
    return (
      new Date(video.fechaSubida).getTime() >
        new Date().getTime() - MILLISECONDS_24_HORAS * diasVisualizacionVideos &&
      (video.estado.codParametro === ESTADO_VIDEO_COMPLETADO ||
        video.estado.codParametro === ESTADO_VIDEO_VISUALIZADO)
    );
  }

  get videosComp(): IVideo[] {
    return this.videos;
  }

  get fields(): IField[] {
    const visibleKeys = this.columnsConfig?.codColumna?.split(",").filter((s) => s !== "") || [];
    let columnas: IField[] = [
      {
        key: "actions-left",
        label: "ACCIONES",
        sortable: false,
        thClass: "table-header table-header-active pl-4",
        tdClass: "table-cell-first",
        visible: true,
        class: "table-cell",
        aux: true,
        code: "",
      },
    ];
    this.columnsConfig.columnas?.forEach((column: IConfColumnaPais) => {
      columnas.push({
        key: column.keyFront,
        label: this.$t("label." + column.codColumna),
        sortable: true,
        thClass: "table-header",
        tdClass: (_value: unknown, key: string): string => `table-cell-middle ${key}`,
        thStyle: column.widthFront ? { width: column.widthFront } : {},
        visible: this.isVisible(visibleKeys, column.codColumna),
        class: "table-cell",
        aux: false,
        code: column.codColumna,
        formatter: (value: any): string => {
          if (column.formatType == "Date") {
            return this.filterDate(value);
          } else if (column.formatType == "Number") {
            return this.filterNumber(value, 2);
          } else if (column.formatType == "Boolean") {
            return this.booleanValue(value, column.keyFront);
          }
          return value;
        },
      });
    });
    columnas.push({
      key: "actions-right",
      label: "",
      sortable: false,
      thClass: "table-header table-header-add-columnas pb-0",
      tdClass: "table-cell",
      visible: true,
      aux: true,
      code: "",
    });
    return columnas;
  }

  set fields(fields: IField[]) {
    this.columnsConfig.codColumna =
      fields
        .filter((item) => item.visible && !item.aux)
        .map((item) => item.code)
        .join(",") || "";
  }

  get visibleFields(): IField[] {
    return this.fields.filter((item) => item.visible);
  }

  isVisible(visibleKeys: string[], column: string): boolean {
    return !visibleKeys.length || !!visibleKeys.find((key) => key === column);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  clickAcciones(action: string, object?: any): void {
    if (action === "sort") {
      this.pagination.direction = object.sortDesc ? EDirection.DESC : EDirection.ASC;
      this.pagination.orderBy = object.sortBy;
      this.saveColumnsConfig();
      this.$emit("input", this.pagination);
      this.$emit("action", { action: "reject", data: this.pagination });
    } else if (action == "pagination") {
      this.pagination.page = object;
      this.$emit("input", this.pagination);
      this.$emit("action", { action: "reject", data: this.pagination });
    } else if (action == "watch") {
      this.$emit("action", { action: "watch", data: object });
    } else if (action == "download") {
      this.$emit("action", { action: "download", data: object });
    } else if (action == "aceptarNovedad") {
      this.$emit("action", { action: "aceptarNovedad", data: object });
    } else if (action == "rechazarNovedad") {
      this.$emit("action", { action: "rechazarNovedad", data: object });
    }
  }

  async clickDelete(video: IVideo): Promise<void> {
    const { isConfirmed } = await this.modalConfirmDeleteVideo();
    if (isConfirmed) {
      this.$emit("action", { action: "delete", data: video });
    }
  }

  async modalConfirmDeleteVideo(): Promise<SweetAlertResult> {
    return this.$swal({
      title: this.$t("label.video.deletion"),
      text: this.$t("label.video.deletion.confirmation.message"),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.$t("label.yes"),
      cancelButtonText: this.$t("label.no"),
    });
  }

  async saveColumnsConfig(): Promise<void> {
    const params: ISoConfColumnasUpdateDTO = {
      codColumna: this.columnsConfig.codColumna || "",
      codTabla: this.columnsConfig.codTabla,
    };
    if (this.pagination) {
      params.codTipoOrden = this.pagination.direction;
      params.numPagElements = this.pagination.size;
      params.codOrden = this.pagination.orderBy;
    }
    await this.saveColumna(params);
  }

  private booleanValue(value: any, keyFront: string) {
    if (keyFront === "aceptado") {
      if (value != undefined) {
        return value ? this.$t("label.si") : this.$t("label.no");
      } else {
        return "";
      }
    } else {
      return value ? this.$t("label.si") : this.$t("label.no");
    }
  }
}
export default VideosTable;
</script>
<style lang="scss" scoped>
.acciones_ClientesTable {
  display: flex;
}
.divActionCell_ClientesTable {
  cursor: pointer;
  margin-left: 1rem;
}
.container_ClientesTable {
  margin-top: 2rem;
}
.table-responsive::v-deep td.table-cell.observaciones {
  max-width: 30em;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tooltip-observaciones::v-deep .tooltip-inner {
  text-align: left;
  white-space: pre-line;
}
</style>
